import React, { useState, useEffect, useCallback } from "react";
import classes from "./ClassRequestEdit.module.css";
import Grid from "@mui/material/Grid";
import { useSelector, useDispatch } from "react-redux";
import { classRequestActions } from "../../Store/ClassRequest";
import Autocomplete from "@mui/material/Autocomplete";
import {
  getProjectDetails,
  postClassRequest,
  getSiteLocatioins,
  createClassRequest,
  getClassRequest,
  getIDMUserDetails,
} from "../../services/userServices";
import { useTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import BackdropComponent from "../Spinner/Spinner";
import moment from "moment";
import TextField from "@mui/material/TextField";
import { SnackBarStoreAction } from "Store/SnackBar";
import { generalStoreActions } from "Store/GeneralStore";
import Modal from "@mui/material/Modal";
import SearchModal from "../RosterConfigComponents/SearchModal/SearchModal";
import Box from "@mui/material/Box";
import SearchIcon from "@mui/icons-material/Search";
import PropTypes from "prop-types";
import applicationUsageLog from "../../utils/applicationUsagesLog";
import pillThemeConfig from "styles/pillThemeConfig";
import { CustomButton } from "components/RosterConfig/RosterConfigStyle";
import { MenuItem, Select, TextareaAutosize, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Checkbox from "@mui/material/Checkbox";
import Paper from "@mui/material/Paper";

const formatDate = (date) =>
  date ? moment(date).format("YYYY-MM-DD") : "YYYY-MM-DD";

const searchStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  height: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "8px",
};

const requestStatus = [
  "In Progress",
  "On Hold",
  "Closed",
  "Cancelled",
  "Extended Training/Nesting - Full",
  "Extended Training/Nesting - Partial",
];
const classType = [
  "",
  "New Launch",
  "Seasonal Growth",
  "Steady State Growth",
  "Attrition",
];
const trainingClass = ["", "PT", "FT"];
const prodClass = [
  "",
  "PT Regular",
  "PT Temporary",
  "FT Regular",
  "FT Temporary",
];
const og = [
  {
    id: "",
    name: "",
  },
  {
    id: 1,
    name: "OG",
  },
  {
    id: 2,
    name: "FDO",
  },
  {
    id: 3,
    name: "N/A",
  },
  {
    id: 4,
    name: "B&M",
  },
  {
    id: 5,
    name: "AT",
  },
];
const productionClassificationData = [
  "",
  "New Hire - @Home Dedicated",
  "New Hire - B&M Dedicated",
  "New Hire - Train @Home,Production Onsite",
  "New Hire - Train B&M,Production @Home",
  "New Hire/Transfer Combination - Train @Home,Production Onsite",
  "New Hire/Transfer Combination - Train B&M,Production @Home",
  "Change Role - @Home Dedicated",
  "Change Role - B&M Dedicated",
  "Change Role - B&M to @Home Migration",
  "Change Role - Client to Client Transfer",
  "Change Role - Technology/Project Change",
];

const ClassRequestEdit = (props) => {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [searchType, setSearchType] = useState("");

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const classRequestDet = useSelector((state) => state.classRequest);
  const parentCLientId = useSelector((state) => state.parentClientId);
  const [searchKeyword, setSearchKeyword] = useState("");

  const [selectedProject, setSelectedProject] = useState([]);
  const [siteLoc, setSiteLoc] = useState([]);

  const [projectDetails, setProjectDetails] = useState([]);
  const [projectFoundList, setProjectFoundList] = useState([]);
  const [showProject, setShowProject] = useState(false);
  const [disableCreate, setDisableCreate] = useState(false);

  const [requestStatusRequired, setRequestStatusRequired] = useState(false);
  const [projectRequired, setProjectRequired] = useState(false);
  const [waveRequired, setWaveRequired] = useState(false);
  const [siteCodeRequired, setSiteCodeRequired] = useState(false);
  const [prodFillGoalRequired, setProdFillGoalRequired] = useState(false);
  const [rosterProdDateRequired, setRosterProdDateRequired] = useState(false);
  const [classTypeRequired, setClassTypeRequired] = useState(false);
  const [checked, setChecked] = useState([]);
  const [left, setLeft] = useState([]);
  const [right, setRight] = useState([]);

  useEffect(() => {
    setLeft(projectFoundList);
  }, [projectFoundList]);

  useEffect(() => {
    setRight(selectedProject);
  }, [selectedProject]);

  useEffect(() => {
    const filteredLeft = projectFoundList.filter(
      (p) => !selectedProject.some((sp) => sp.projectCode === p.projectCode),
    );
    setLeft(filteredLeft);
  }, [projectFoundList, selectedProject]);

  const not = (a, b) =>
    a.filter((value) => !b.some((v) => v.projectCode === value.projectCode));
  const intersection = (a, b) =>
    a.filter((value) => b.some((v) => v.projectCode === value.projectCode));

  const leftChecked = intersection(checked, projectFoundList);
  const rightChecked = intersection(checked, selectedProject);

  const handleToggle = (project) => {
    const exsists = checked.some((p) => p.projectCode === project.projectCode);
    if (exsists) {
      setChecked(checked.filter((p) => p.projectCode !== project.projectCode));
    } else {
      setChecked([...checked, project]);
    }
  };

  const handleAllRight = () => {
    const updatedRight = [...right, ...left];
    setLeft([]);
    setRight(updatedRight);
    setChecked(not(checked, left));
    setSelectedProject(updatedRight);

    const filtered = projectFoundList.filter(
      (p) =>
        (p.projectName.toLowerCase().includes(searchKeyword.toLowerCase()) ||
          p.projectCode.toLowerCase().includes(searchKeyword.toLowerCase())) &&
        !updatedRight.some((r) => r.projectCode === p.projectCode),
    );
    setLeft(filtered);
    setProjectFoundList([]);
  };

  const handleCheckedRight = () => {
    setSelectedProject([...selectedProject, ...leftChecked]);
    setProjectFoundList(not(projectFoundList, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setProjectFoundList([...projectFoundList, ...rightChecked]);
    setSelectedProject(not(selectedProject, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  const handleAllLeft = () => {
    const updatedLeft = [...left, ...right];
    setRight([]);
    setLeft(updatedLeft);
    setChecked(not(checked, right));
    setSelectedProject([]);
    setProjectFoundList(updatedLeft);

    const filtered = projectFoundList.filter(
      (p) =>
        (p.projectName.toLowerCase().includes(searchKeyword.toLowerCase()) ||
          p.projectCode.toLowerCase().includes(searchKeyword.toLowerCase())) &&
        ![].some((r) => r.projectCode === p.projectCode),
    );
    setRight(filtered);
  };

  const initialSiteValue = {
    GeoLocCd: "",
    GeoLocName: "",
    SiteLIST: "",
  };

  const numberRegex = /(^[+]?\d*$)/;
  const classFillGoalRegex = /(^[+-]?\d*[.]?\d*%?$)/;

  const { t } = useTranslation(["createClassRequest"]);

  const isMultiProjectCode = (projectCode) => {
    return projectCode && projectCode.includes(",");
  };

  const getAvailableProjectCodes = (projectCode) => {
    return projectCode.split(",");
  };

  const filterSelectedProjects = (projects, availableProjectCodes) => {
    return projects.filter((el) =>
      availableProjectCodes.includes(el.projectCode),
    );
  };

  const filterRemainingProjects = (projects, availableProjectCodes) => {
    return projects.filter(
      (el) => !availableProjectCodes.includes(el.projectCode),
    );
  };

  const handleSingleProject = (
    projects,
    projectCode,
    setSelectedProject,
    setProjectFoundList,
  ) => {
    const selectedProjects = projects.filter(
      (itm) => itm.projectCode === projectCode,
    );
    setSelectedProject(selectedProjects);

    const remainingProjects = projects.filter(
      (el) => el.projectCode !== projectCode,
    );
    setProjectFoundList(remainingProjects);
  };

  const handleMultipleProjects = (
    projects,
    projectCode,
    setSelectedProject,
    setProjectFoundList,
  ) => {
    const availableProjectCodes = getAvailableProjectCodes(projectCode);
    const selectedProjects = filterSelectedProjects(
      projects,
      availableProjectCodes,
    );
    const remainingProjects = filterRemainingProjects(
      projects,
      availableProjectCodes,
    );

    setSelectedProject(selectedProjects);
    setProjectFoundList(remainingProjects);
  };

  const setProjects = useCallback(
    (projects) => {
      if (isMultiProjectCode(classRequestDet.projectCode)) {
        handleMultipleProjects(
          projects,
          classRequestDet.projectCode,
          setSelectedProject,
          setProjectFoundList,
        );
      } else {
        handleSingleProject(
          projects,
          classRequestDet.projectCode,
          setSelectedProject,
          setProjectFoundList,
        );
      }
    },
    [classRequestDet],
  );

  useEffect(() => {
    let cancelled = false;

    const initialize = async () => {
      try {
        if (props.type === "edit") {
          const opsApproverOracleId =
            props.classRequestDetails?.opsApproverOracleId;
          if (
            opsApproverOracleId !== null &&
            opsApproverOracleId !== undefined
          ) {
            await fetchuserDetails(opsApproverOracleId, props.type);
          }
        }

        if (!cancelled) {
          applicationUsageLog(
            localStorage.getItem("User"),
            localStorage.getItem("EmailId"),
            "ASTT",
            "CLASS REQUEST DETAILS",
          );
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to initialize:", error);
        }
      }
    };

    initialize();

    return () => {
      cancelled = true;
    };
  }, []);

  const fetchuserDetails = async (OracleId, type) => {
    if (type !== "edit" || !props.classRequestDetails?.opsApproverOracleId) {
      return;
    }

    setLoading(true);
    const userDetails = await getIDMUserDetails(
      props.classRequestDetails.opsApproverOracleId,
    );

    if (userDetails.status === true) {
      let objuserDetails = JSON.parse(userDetails["data"]);
      dispatch(
        classRequestActions.updateOpsApprovalName(
          objuserDetails.result[0].name,
        ),
      );
    }
    setLoading(false);
  };

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      if (!classRequestDet.resetHandler) {
        return;
      }

      if (!cancelled) {
        setLoading(true);
        dispatch(classRequestActions.resetHandlerFunction(false));
      }

      try {
        await retrieveProjectDetails();

        if (cancelled) return;

        const siteLoc = await getSiteLocatioins();

        if (cancelled) return;

        if (siteLoc.message === "Success") {
          if (!cancelled) {
            setSiteLoc(siteLoc.data);
            setSiteLocation();
          }
        }

        if (!cancelled) {
          updateOgBasedOnType();
          setLoading(false);
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch data:", error);
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, [classRequestDet]);

  const updateOgBasedOnType = () => {
    if (props.type === "edit") {
      if (classRequestDet.og === null) {
        dispatch(classRequestActions.updateOg(og[0].id));
      }
    } else {
      dispatch(classRequestActions.updateOg(og[0].id));
      dispatch(classRequestActions.updateClassType(classType[0]));
    }
  };

  const retrieveProjectDetails = async () => {
    const projectDetails = await getProjectDetails(
      parentCLientId.parentClientId,
    );

    if (projectDetails.status !== true) {
      return;
    }

    setProjectDetails(projectDetails.data.projectDetails);
    setProjectFoundList(projectDetails.data.projectDetails);
    setProjects(projectDetails.data.projectDetails);

    if (props.type !== "edit") {
      initializeDefaultValues();
    }
  };

  const initializeDefaultValues = () => {
    dispatch(classRequestActions.updateRequestStatus(requestStatus[0]));
    dispatch(classRequestActions.updateOg(og[0].id));
    dispatch(classRequestActions.updateClassType(classType[0]));
  };

  useEffect(() => {
    let cancelled = false;

    const fetchProjectDetails = async () => {
      try {
        await retrieveProjectDetails();

        if (cancelled) return;

        const siteLoc = await getSiteLocatioins();

        if (cancelled) return;

        if (siteLoc.message === "Success") {
          if (!cancelled) {
            setSiteLoc(siteLoc.data);
          }
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch project details:", error);
        }
      }
    };

    fetchProjectDetails();

    return () => {
      cancelled = true;
    };
  }, [parentCLientId, classRequestDet.projectCode]);

  const siteLocProps = {
    options: siteLoc,
    getOptionLabel: (option) => option.GeoLocName,
  };

  const [value, setValue] = useState({});

  const setSiteLocation = () => {
    if (props.type !== "edit" || !Array.isArray(siteLocProps.options)) {
      return;
    }

    let option = siteLocProps.options.filter(
      (itm) => itm.GeoLocCd === classRequestDet.siteCode,
    );

    if (option.length > 0) {
      setValue(option[0]);
    }
  };

  useEffect(() => {
    setSiteLocation();
  }, [siteLocProps.options]);

  const buildClassRequestObject = () => {
    const projects = selectedProject
      .map(function (item) {
        return item["projectCode"];
      })
      .join();

    return {
      classFillGoal: classRequestDet.classFillGoal || "",
      classType: classRequestDet.classType,
      gpmpoc: classRequestDet.gpmPoc,
      hiringBands: classRequestDet.hiringBands,
      modifiedBy: localStorage.getItem("User"),
      numberOfClasses: classRequestDet.noOfClasses,
      productionClassfication: classRequestDet.productionClassification,
      productionFillGoalBillable: classRequestDet.prodFillGoalBillable || 0,
      productionFillGoalNonBillable:
        classRequestDet.prodFillGoalNonBillable || 0,
      projectCode: projects,
      requestStatus: classRequestDet.requestStatus,
      rosterLockDate: classRequestDet.rosterLockDate,
      siteCode: classRequestDet.site,
      trainingClassification: classRequestDet.trainingClassification,
      trainingProduction: classRequestDet.trainingSolution,
      classApprovalDate: classRequestDet.classApprovalDate,
      classApprovalComments: classRequestDet.classApprovalComments,
      wave: classRequestDet.wave.toString(),
      onboardingSupportedById: classRequestDet.og,
      opsApprovalDate: classRequestDet.opsApprovalDate,
      OpsApproverOracleId: classRequestDet.opsApproverOracleId,
    };
  };

  const updateClassRequest = async () => {
    const obj = buildClassRequestObject();
    validateFields(obj);

    if (!validateClassRequestCreation(obj)) {
      return;
    }

    setLoading(true);
    const update = await postClassRequest(classRequestDet.classRequestId, obj);

    if (update.message === "Success") {
      Snackhandler(true, "Updated Successfully !!!", "success");
      props.onUpdate();
      setLoading(true);
    } else {
      Snackhandler(true, "Failed to save !", "error");
      setLoading(false);
    }

    props.onClose("right", false, "add");
  };

  useEffect(() => {
    const isFormValid = checkFormValidity();
    setDisableCreate(!isFormValid);
  }, [
    classRequestDet.requestStatus,
    selectedProject,
    classRequestDet.siteCode,
    classRequestDet.site,
    classRequestDet.wave,
    classRequestDet.prodFillGoal,
    classRequestDet.rosterProdStartDate,
    classRequestDet.classType,
  ]);

  const checkFormValidity = () => {
    return (
      classRequestDet.requestStatus !== "" &&
      classRequestDet.siteCode !== "" &&
      classRequestDet.wave !== "" &&
      classRequestDet.prodFillGoal !== "" &&
      selectedProject.length > 0 &&
      classRequestDet.rosterProdStartDate !== null &&
      classRequestDet.rosterProdStartDate !== "" &&
      classRequestDet.rosterProdStartDate !== "Invalid date" &&
      classRequestDet.classType !== ""
    );
  };

  const Snackhandler = (open, message, severity) => {
    const obj = {
      open: open,
      message: message,
      severity: severity,
    };

    dispatch(SnackBarStoreAction.updateSnack(obj));
  };

  const validateClassRequestCreation = (obj) =>
    obj.requestStatus !== "" &&
    obj.projectCode !== "" &&
    obj.site !== "" &&
    obj.wave !== "" &&
    obj.rosterProdStartDate !== "" &&
    obj.classType !== "";

  const validateFields = (obj) => {
    setRequestStatusRequired(obj.requestStatus === "");
    setProjectRequired(obj.projectCode === "");
    setSiteCodeRequired(obj.siteCode === "");
    setWaveRequired(obj.wave === "");
    setRosterProdDateRequired(obj.rosterProdStartDate === "");
    setClassTypeRequired(obj.classType === "");
  };

  const createClassReq = async () => {
    const projects = selectedProject.map((item) => item["projectCode"]).join();
    const obj = {
      classFillGoal: classRequestDet.classFillGoal,
      classType: classRequestDet.classType,
      gpmpoc: classRequestDet.gpmPoc,
      hiringBands: classRequestDet.hiringBands,
      numberOfClasses: classRequestDet.noOfClasses || "",
      productionClassfication: classRequestDet.productionClassification,
      productionFillGoalBillable: classRequestDet.prodFillGoalBillable || 0,
      productionFillGoalNonBillable:
        classRequestDet.prodFillGoalNonBillable || 0,
      projectCode: projects,
      requestStatus: classRequestDet.requestStatus,
      rosterLockDate: classRequestDet.rosterLockDate,
      siteCode: classRequestDet.site,
      trainingClassification: classRequestDet.trainingClassification,
      trainingProduction: classRequestDet.trainingSolution,
      wave: classRequestDet.wave,
      rosterProdStartDate: classRequestDet.rosterProdStartDate,
      onboardingSupportedById: classRequestDet.og,
      classApprovalDate: classRequestDet.classApprovalDate,
      classApprovalComments: classRequestDet.classApprovalComments,
      opsApprovalDate: classRequestDet.opsApprovalDate,
      OpsApproverOracleId: classRequestDet.opsApproverOracleId,
      modifiedBy: localStorage.getItem("User"),
    };

    let date = moment(obj.rosterProdStartDate);
    if (!date.isValid()) {
      setRosterProdDateRequired(true);
      return;
    }

    if (!validateClassRequestCreation(obj)) {
      setLoading(false);
      validateFields(obj);
      return;
    }

    await performCreate(obj);
  };

  const performCreate = async (obj) => {
    setLoading(true);
    const create = await createClassRequest(obj);
    setDisableCreate(false);

    if (create.message === "Success") {
      Snackhandler(true, "Created Successfully !!!", "success");
      setLoading(true);
    } else {
      Snackhandler(true, "Failed to save !", "error");
      setLoading(false);
    }

    props.onClose("right", false, "add");
  };

  const showProjectSelector = async () => {
    dispatch(generalStoreActions.updateShowProject(true));
    setShowProject(true);
  };

  const showFormField = () => {
    dispatch(generalStoreActions.updateShowProject(false));
    setProjectRequired(selectedProject.length === 0);
    setShowProject(false);
  };

  const waveChange = (event) => {
    if (event.target.value === "") {
      setWaveRequired(true);
      dispatch(classRequestActions.updateWave(event.target.value));
    } else {
      setWaveRequired(false);
      numberRegex.test(event.target.value) &&
        dispatch(classRequestActions.updateWave(event.target.value));
    }
  };

  const filter = (e) => {
    const keyword = e.target.value;
    setSearchKeyword(keyword);

    if (keyword !== "") {
      const results = projectDetails.filter(
        (obj) =>
          JSON.stringify(obj).toLowerCase().includes(keyword.toLowerCase()) &&
          !selectedProject.some((sp) => sp.projectCode === obj.projectCode),
      );
      setProjectFoundList(results);
    } else {
      setSearchKeyword("");
      const filtered = projectDetails.filter(
        (obj) =>
          !selectedProject.some((sp) => sp.projectCode === obj.projectCode),
      );
      setProjectFoundList(filtered);
    }
  };

  const handleRosterLockDate = (newDate) => {
    dispatch(classRequestActions.updateRosterLockDate(newDate));
  };

  const handleApprovalDate = (newDate) => {
    dispatch(classRequestActions.updateClassApprovalDate(newDate));
  };

  const handleRosterProdStartDate = (newDate) => {
    if (newDate === "") {
      setRosterProdDateRequired(true);
      dispatch(classRequestActions.updateRosterProdStartDate(null));
    } else {
      setRosterProdDateRequired(false);
      dispatch(classRequestActions.updateRosterProdStartDate(newDate));
    }
  };

  const resetSiteLoc = () => {
    setSiteLoc(initialSiteValue);
    setValue({});
  };

  const resetHandler = useCallback(() => {
    dispatch(classRequestActions.resetClassReq());
    dispatch(classRequestActions.resetHandlerFunction(true));
    resetSiteLoc();
  }, []);

  const handleReset = useCallback(async (classRequestId) => {
    const data = await getClassRequest(classRequestId);
    if (data.status === true) {
      dispatch(classRequestActions.resetHandlerFunction(true));
      dispatch(
        classRequestActions.addClassRequest(data.data.classRequestDetail),
      );
      fetchuserDetails(props.classRequestDetails.opsApproverOracleId, "edit");
      setLoading(false);
    } else {
      setLoading(false);
    }
    resetSiteLoc();
  }, []);

  const handleSearchClose = useCallback(() => {
    setModalOpen(false);
  });

  const handleOpenSearch = useCallback((type) => {
    setSearchType(type);
    setModalOpen(true);
  });

  const handleOpsApprovalDate = (newDate) => {
    dispatch(classRequestActions.updateOpsApprovalDate(newDate));
  };

  const formatOpsName = (name, oracleId) => {
    const opsName = name || "";
    const opsApproverOracleId = oracleId || "";

    return `${opsName} - ${opsApproverOracleId}`;
  };

  const updateProdFillGoal = (billable, nonBillable) => {
    const sum = (parseFloat(billable) || 0) + (parseFloat(nonBillable) || 0);
    dispatch(classRequestActions.updateProdFillGoal(sum));
  };

  const missingFields = [];
  if (prodFillGoalRequired) {
    missingFields.push("Prod Fill Goal");
  }
  const isBillableEmpty =
    classRequestDet.prodFillGoalBillable === "" ||
    classRequestDet.prodFillGoalBillable === null;
  const isNonBillableEmpty =
    classRequestDet.prodFillGoalNonBillable === "" ||
    classRequestDet.prodFillGoalNonBillable === null;
  if (isBillableEmpty && isNonBillableEmpty) {
    missingFields.push(" Either Billable or Non-Billable");
  }

  return (
    <>
      {loading ? <BackdropComponent /> : null}
      <Modal
        open={modalOpen}
        onClose={handleSearchClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={searchStyle}>
          <SearchModal
            onClose={handleSearchClose}
            type={searchType}
          ></SearchModal>
        </Box>
      </Modal>

      {!showProject ? (
        <Grid container columnSpacing={1}>
          <Grid
            item
            xs={7}
            sx={{
              borderRadius: "10px",
              border: "3px solid",
              borderColor: pillThemeConfig.WFM.primaryColor,
              boxShadow: `0px 0px 4px ${pillThemeConfig.WFM.primaryColor}`,
            }}
          >
            <Grid container>
              {props.type === "edit" && (
                <>
                  <Grid
                    className={classes.keyData}
                    sx={{
                      paddingTop: 2,
                    }}
                    item
                    xs={12}
                  >
                    <span className={classes.spanTagNecessary}>
                      {t("Last Modified:")}
                    </span>
                  </Grid>
                  <Grid className={classes.valueData} item xs={12}>
                    {classRequestDet.lastModified} (
                    {moment
                      .utc(classRequestDet.modifiedDate)
                      .format("YYYY-MM-DD hh:mm:ss A")}
                    )
                  </Grid>
                </>
              )}

              <Grid
                className={classes.keyData}
                sx={{ paddingTop: 2 }}
                item
                xs={12}
              >
                <span className={classes.spanTagNecessary}>
                  {t("Project(GWFM)*")}
                </span>
              </Grid>
              <Grid className={`${classes.valueData} `} item xs={10}>
                <div className={classes.projectArea}>
                  {selectedProject.map((project, i) => (
                    <Tooltip
                      key={project.projectCode}
                      title={
                        project.projectName +
                        " " +
                        "(" +
                        project.projectCode +
                        ")"
                      }
                      arrow
                    >
                      <p
                        key={project.projectCode}
                        className={classes.projectList}
                      >
                        {project.projectName} ({project.projectCode})
                      </p>
                    </Tooltip>
                  ))}
                </div>
                <Button
                  sx={{
                    marginTop: 2,
                    backgroundColor: "#3299FF",
                    borderRadius: "8px",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={showProjectSelector}
                >
                  Select Project(s)
                </Button>

                <p className="redColor">
                  {" "}
                  {projectRequired && "Please fill the required field Project"}
                </p>
              </Grid>
              <Grid className={classes.keyData} item xs={12}>
                <span className={classes.spanTagNecessary}>
                  {" "}
                  {t("Site/Location(GWFM)*")}
                </span>
              </Grid>
              <Grid
                item
                xs={8.5}
                sx={{
                  marginLeft: "2px",
                }}
                className={classes.valueData}
              >
                <Autocomplete
                  hiddenLabel="true"
                  value={value}
                  options={siteLocProps.options}
                  getOptionLabel={(option) =>
                    option.GeoLocName
                      ? option.GeoLocName + " " + "(" + option.GeoLocCd + ")"
                      : ""
                  }
                  onChange={(event, value, reason) => {
                    if (value) {
                      setSiteCodeRequired(false);
                      setValue(value);
                      dispatch(
                        classRequestActions.updateSiteLocation(value.GeoLocCd),
                      );
                      if (props.type === "add") {
                        if (
                          value.GeoLocCd === "446" ||
                          value.GeoLocCd === "947"
                        ) {
                          dispatch(classRequestActions.updateOg(og[1].id));
                        } else {
                          dispatch(classRequestActions.updateOg(og[0].id));
                        }
                      }
                    } else {
                      setSiteCodeRequired(true);
                      dispatch(classRequestActions.updateSiteLocation(""));
                    }
                    if (reason === "clear") {
                      setSiteCodeRequired(true);
                      setValue({});
                      dispatch(classRequestActions.updateSiteLocation(""));
                    }
                  }}
                  renderOption={(props, option) => {
                    return (
                      <li {...props} key={option.GeoLocCd}>
                        {option.GeoLocName + " " + "(" + option.GeoLocCd + ")"}
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      sx={{
                        color: "#3f5765",
                      }}
                      {...params}
                      variant="outlined"
                      fullWidth
                      placeholder="Select a Site/Location"
                    />
                  )}
                />
                <p className="redColor">
                  {" "}
                  {siteCodeRequired && "Please fill the required field Site"}
                </p>
              </Grid>
              <Grid className={classes.keyData} item xs={12}>
                <span className={classes.spanTagNecessary}>
                  {t("Wave # (GWFM)*")}
                </span>
              </Grid>
              <Grid className={classes.valueData} item xs={10}>
                <Box
                  component="input"
                  name="wave"
                  className={classes.greenData}
                  type="text"
                  value={classRequestDet.wave}
                  onChange={(e) => waveChange(e)}
                  sx={{
                    width: "24rem",
                    color: "#3f5765",
                  }}
                />

                <p className="redColor">
                  {" "}
                  {waveRequired && "Please fill the required field Wave"}
                </p>
              </Grid>

              <Grid className={classes.keyData} item xs={4.3}>
                <span className={classes.spanTagNecessary}>
                  {t("Prod Fill Goal(GWFM)*")}
                </span>
              </Grid>
              <Grid className={classes.keyData} item xs={2}>
                <span>{t("Billable")}</span>
              </Grid>
              <Grid className={classes.keyData} item xs={3}>
                <span>{t("Non-Billable")}</span>
              </Grid>
              <Grid item xs={2.7}></Grid>
              <Grid className={classes.valueData} item xs={4}>
                <Tooltip title="ProdFillGoal is a Read only Field">
                  <Box
                    component="input"
                    name="prodFillGoal"
                    className={classes.prodFillData}
                    type="number"
                    value={classRequestDet.prodFillGoal}
                    readOnly
                    sx={{
                      width: "60px",
                      color: "#3f5765",
                    }}
                  />
                </Tooltip>

                {missingFields.length > 0 && (
                  <Box
                    sx={{
                      backgroundColor: "#ffe5e5",
                      padding: "10px",
                      borderRadius: "5px",
                      display: "flex",
                      color: "black",
                      fontSize: "12px",
                      width: "25rem",
                      marginTop: "10px",
                      fontFamily: "Urbanist",
                    }}
                  >
                    <ErrorOutlineIcon
                      sx={{
                        marginRight: "2px",
                        color: "#E23636",
                        fontSize: "16px",
                      }}
                    />
                    <Typography
                      sx={{
                        fontSize: "12px",
                      }}
                    >
                      Please fill the Required Field:
                      {missingFields.join(",")} to fill ProdFillGoal
                    </Typography>
                  </Box>
                )}
              </Grid>
              <Grid className={classes.valueData} item xs={2}>
                <Box
                  component="input"
                  name="prodFillGoalBillable"
                  className={classes.prodFillData}
                  type="number"
                  min="0"
                  value={classRequestDet.prodFillGoalBillable}
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e") {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => {
                    const value = e.target.value;
                    dispatch(
                      classRequestActions.updateProdFillGoalBillable(value),
                    );
                    updateProdFillGoal(
                      value,
                      classRequestDet.prodFillGoalNonBillable,
                    );
                  }}
                  sx={{
                    marginLeft: "5px",
                    width: "60px",
                    color: "#3f5765",
                  }}
                />
              </Grid>
              <Grid className={classes.valueData} item xs={3}>
                <Box
                  component="input"
                  name="prodFillGoalNonBillable"
                  className={classes.prodFillData}
                  type="number"
                  min="0"
                  value={classRequestDet.prodFillGoalNonBillable}
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e") {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => {
                    const value = e.target.value;
                    dispatch(
                      classRequestActions.updateProdFillGoalNonBillable(value),
                    );
                    updateProdFillGoal(
                      classRequestDet.prodFillGoalBillable,
                      value,
                    );
                  }}
                  sx={{
                    width: "60px",
                    marginLeft: "5px",
                    color: "#3f5765",
                  }}
                />
              </Grid>
              <Grid item xs={3}></Grid>
              {props.type === "add" && (
                <>
                  <Grid className={classes.keyData} item xs={12}>
                    <span className={classes.spanTagNecessary}>
                      {t("Roster Prod Start Date(GWFM)*")}
                    </span>
                  </Grid>
                  <Grid className={classes.valueData} item xs={10}>
                    <Box
                      component="input"
                      id="date"
                      type="date"
                      value={formatDate(classRequestDet.rosterProdStartDate)}
                      onChange={(e) =>
                        handleRosterProdStartDate(e.target.value)
                      }
                      onKeyDown={(e) => {
                        handleRosterProdStartDate(
                          e.key === "Backspace" ? "" : e.target.value,
                        );
                      }}
                      sx={{
                        fontWeight:
                          classRequestActions.updateAssignRosterLockDate
                            ? "normal"
                            : 300,
                        color: classRequestDet.rosterProdStartDate
                          ? "#3f5765"
                          : "#888",
                        height: "30px",
                        width: "24rem",
                        borderRadius: "5px",
                        border: "1px solid #ADB5B5",
                        marginBottom: "5px",
                      }}
                    />

                    <p className="redColor">
                      {" "}
                      {rosterProdDateRequired &&
                        "Please fill the required field Roster Prod Start Date"}
                    </p>
                  </Grid>
                </>
              )}

              <Grid className={classes.keyData} item xs={12}>
                <span className={classes.spanTagNecessary}>
                  {t("Class Type(GWFM)*")}
                </span>
              </Grid>
              <Grid className={classes.valueData} item xs={10}>
                <Box
                  component="select"
                  className={classes.greenData}
                  value={classRequestDet.classType}
                  onChange={(event) => {
                    if (event.target.value) {
                      setClassTypeRequired(false);
                      dispatch(
                        classRequestActions.updateClassType(event.target.value),
                      );
                    } else {
                      setClassTypeRequired(true);
                      dispatch(classRequestActions.updateClassType(""));
                    }
                  }}
                  sx={{
                    width: "24rem",
                    color: "#3f5765",
                  }}
                  placeholder="Select an option"
                >
                  {classType.map((value) => (
                    <option key={value} value={value}>
                      {value}
                    </option>
                  ))}
                </Box>

                <p className="redColor">
                  {" "}
                  {classTypeRequired &&
                    "Please fill the required field class type"}
                </p>
              </Grid>
              <Grid className={classes.keyData} item xs={12}>
                <Box
                  className={classes.spanTagNecessary}
                  component={"span"}
                  sx={{ display: "inline-block" }}
                >
                  {" "}
                  {t("Training/Production Solution(GWFM)")}
                </Box>
              </Grid>
              <Grid className={classes.valueData} item xs={10}>
                <Box
                  component="select"
                  className={classes.greenData}
                  value={classRequestDet.trainingSolution}
                  onChange={(e) =>
                    dispatch(
                      classRequestActions.updateTrainingSolution(
                        e.target.value,
                      ),
                    )
                  }
                  sx={{
                    width: "24rem",
                    color: "#3f5765",
                  }}
                  placeholder="Select an option"
                >
                  {productionClassificationData.map((value) => (
                    <option key={value} value={value}>
                      {value}
                    </option>
                  ))}
                </Box>
              </Grid>

              <Grid className={classes.keyData} item xs={12}>
                <span className={classes.spanTagNecessary}>
                  {" "}
                  {t("FT/PT Training Classification (GWFM)")}
                </span>
              </Grid>
              <Grid className={classes.valueData} item xs={10}>
                <Box
                  component="select"
                  className={classes.greenData}
                  value={classRequestDet.trainingClassification}
                  onChange={(e) =>
                    dispatch(
                      classRequestActions.updateTrainingClassification(
                        e.target.value,
                      ),
                    )
                  }
                  sx={{
                    width: "24rem",
                    color: "#3f5765",
                  }}
                  placeholder="Select an option"
                >
                  {trainingClass.map((value) => (
                    <option key={value} value={value}>
                      {value}
                    </option>
                  ))}
                </Box>
              </Grid>
              <Grid className={classes.keyData} item xs={12}>
                <span className={classes.spanTagNecessary}>
                  {" "}
                  {t("FT/PT Production Classification (GWFM)")}
                </span>
              </Grid>
              <Grid className={classes.valueData} item xs={10}>
                <Box
                  component="select"
                  className={classes.greenData}
                  value={classRequestDet.productionClassification}
                  onChange={(e) =>
                    dispatch(
                      classRequestActions.updateProdClassification(
                        e.target.value,
                      ),
                    )
                  }
                  sx={{
                    width: "24rem",
                    color: "#3f5765",
                  }}
                  placeholder="Select an option"
                >
                  {prodClass.map((value) => (
                    <option key={value} value={value}>
                      {value}
                    </option>
                  ))}
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={5}>
            <Grid container rowGap={1}>
              <Grid
                item
                xs={12}
                sx={{
                  borderRadius: "10px",
                  padding: "5%",
                  border: "3px solid",
                  borderColor: pillThemeConfig.LD.primaryColor,
                  boxShadow: `0px 0px 4px ${pillThemeConfig.LD.primaryColor}`,
                }}
              >
                <Grid container>
                  <Grid className={classes.keyData} item xs={12}>
                    <span className={classes.spanTagNecessary}>
                      {t("Request Status*")}
                    </span>
                  </Grid>
                  <Grid className={classes.valueData} item xs={8}>
                    import {Box} from "@mui/material";
                    <Box
                      component="select"
                      className={classes.allData}
                      value={classRequestDet.requestStatus}
                      onChange={(e) =>
                        dispatch(
                          classRequestActions.updateRequestStatus(
                            e.target.value,
                          ),
                        )
                      }
                      sx={{
                        color: "#3f5765",
                      }}
                      placeholder="Select an option"
                    >
                      {requestStatus.map((value) => (
                        <option key={value} value={value}>
                          {value}
                        </option>
                      ))}
                    </Box>
                    <p className="redColor">
                      {" "}
                      {requestStatusRequired && "Request Status Required"}
                    </p>
                  </Grid>
                  <Grid className={classes.keyData} item xs={12}>
                    <span className={classes.spanTagNecessary}>
                      {" "}
                      {t("Number Of Classes")}
                    </span>
                  </Grid>
                  <Grid className={classes.valueData} item xs={8}>
                    <Box
                      component="input"
                      name="noOfClasses"
                      className={classes.allData}
                      type="text"
                      value={classRequestDet.noOfClasses}
                      onChange={(e) => {
                        classFillGoalRegex.test(e.target.value) &&
                          dispatch(
                            classRequestActions.updateNoOfClasses(
                              e.target.value,
                            ),
                          );
                      }}
                      sx={{
                        color: "#3f5765",
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{
                  borderRadius: "10px",

                  padding: "5%",
                  border: "3px solid",
                  borderColor: pillThemeConfig.TA.primaryColor,
                  boxShadow: `0px 0px 4px ${pillThemeConfig.TA.primaryColor}`,
                }}
              >
                <Grid container>
                  <Grid className={classes.keyData} item xs={12}>
                    <span className={classes.spanTagNecessary}>
                      {" "}
                      {t("Class Fill Goal(TA)")}
                    </span>
                  </Grid>
                  <Grid className={classes.valueData} item xs={8}>
                    <Box
                      component="input"
                      name="classFillGoal"
                      className={classes.allData}
                      type="text"
                      value={classRequestDet.classFillGoal}
                      onChange={(e) => {
                        classFillGoalRegex.test(e.target.value) &&
                          dispatch(
                            classRequestActions.updateClassFillGoal(
                              e.target.value,
                            ),
                          );
                      }}
                      sx={{
                        color: "#3f5765",
                      }}
                    />
                  </Grid>
                  <Grid className={classes.keyData} item xs={12}>
                    <span className={classes.spanTagNecessary}>
                      {t("Roster Lock Date (TA)")}
                    </span>
                  </Grid>
                  <Grid className={classes.valueData} item xs={8}>
                    <Box
                      component="input"
                      id="date"
                      className={classes.allData}
                      type="date"
                      value={formatDate(classRequestDet.rosterLockDate)}
                      onChange={(e) =>
                        handleRosterLockDate(
                          e.target.value === "" ? null : e.target.value,
                        )
                      }
                      onKeyDown={(e) => {
                        handleRosterLockDate(
                          e.key === "Backspace" ? null : e.target.value,
                        );
                      }}
                      sx={{
                        width: "100%",
                        fontWeight: classRequestDet.rosterLockDate
                          ? "normal"
                          : 300,
                        color: classRequestDet.rosterLockDate
                          ? "#3f5765"
                          : "#888",
                      }}
                    />
                  </Grid>
                  <Grid className={classes.keyData} item xs={12}>
                    <span className={classes.spanTagNecessary}>
                      {t("Class Approval Date (TA)")}
                    </span>
                  </Grid>
                  <Grid className={classes.valueData} item xs={8}>
                    <Box
                      component="input"
                      id="date"
                      className={classes.allData}
                      type="date"
                      value={formatDate(classRequestDet.classApprovalDate)}
                      onChange={(e) =>
                        handleApprovalDate(
                          e.target.value === "" ? null : e.target.value,
                        )
                      }
                      onKeyDown={(e) => {
                        handleApprovalDate(
                          e.key === "Backspace" ? null : e.target.value,
                        );
                      }}
                      sx={{
                        width: "100%",
                        fontWeight: classRequestDet.classApprovalDate
                          ? "normal"
                          : 300,
                        color: classRequestDet.classApprovalDate
                          ? "#3f5765"
                          : "#888",
                      }}
                    />
                  </Grid>
                  <Grid className={classes.keyData} item xs={12}>
                    <span className={classes.spanTagNecessary}>
                      {t("Class Approval Comments (TA)")}
                    </span>
                  </Grid>
                  <Grid className={classes.valueData} item xs={8}>
                    <TextareaAutosize
                      name="classAppCmt"
                      className={classes.allData}
                      type="text"
                      maxLength={1000}
                      placeholder="Max 1000 characters allowed"
                      value={classRequestDet.classApprovalComments}
                      sx={{
                        fontFamily: "Arial, sans-serif",
                        fontSize: "13px",
                        color: "#3f5765",
                      }}
                      onChange={(e) =>
                        dispatch(
                          classRequestActions.updateClassApprovalCmt(
                            e.target.value,
                          ),
                        )
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{
                  borderRadius: "10px",

                  padding: "5%",
                  border: "3px solid",
                  borderColor: pillThemeConfig.OG.primaryColor,
                  boxShadow: `0px 0px 4px ${pillThemeConfig.OG.primaryColor}`,
                }}
              >
                <Grid container>
                  <Grid className={classes.keyData} item xs={12}>
                    <span className={classes.spanTagNecessary}>
                      {" "}
                      {t("On-boarding Supported By (OG)")}
                    </span>
                  </Grid>
                  <Grid className={classes.valueData} item xs={8}>
                    <Select
                      value={classRequestDet.og}
                      onChange={(e) => {
                        dispatch(classRequestActions.updateOg(e.target.value));
                      }}
                      className={classes.allData}
                      displayEmpty
                      sx={{
                        color: "#3f5765",
                      }}
                    >
                      {og.map((value) => (
                        <MenuItem key={value.id} value={value.id}>
                          {value.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid className={classes.keyData} item xs={12}>
                    <span className={classes.spanTagNecessary}>
                      {t("GPM POC (OG)")}
                    </span>
                  </Grid>
                  <Grid className={classes.valueData} item xs={8}>
                    <TextField
                      name="gpm"
                      className={classes.allData}
                      type="text"
                      value={classRequestDet.gpmPoc}
                      onChange={(e) =>
                        dispatch(
                          classRequestActions.updateGpmPoc(e.target.value),
                        )
                      }
                      sx={{
                        color: "#3f5765",
                      }}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{
                  borderRadius: "10px",

                  padding: "5%",
                  border: "3px solid",
                  borderColor: pillThemeConfig.OPS.primaryColor,
                  boxShadow: `0px 0px 4px ${pillThemeConfig.OPS.primaryColor}`,
                }}
              >
                <Grid container>
                  <Grid className={classes.keyData} item xs={12}>
                    <span className={classes.spanTagNecessary}>
                      {" "}
                      {t("OpsApprovalDate")}
                    </span>
                  </Grid>
                  <Grid className={classes.valueData} item xs={12}>
                    import {TextField} from '@mui/material';
                    <TextField
                      id="date"
                      name="opsApprovalDate"
                      type="date"
                      className={classes.allData}
                      value={formatDate(classRequestDet.opsApprovalDate)}
                      onChange={(e) =>
                        handleOpsApprovalDate(
                          e.target.value === "" ? null : e.target.value,
                        )
                      }
                      onKeyDown={(e) => {
                        handleOpsApprovalDate(
                          e.key === "Backspace" ? null : e.target.value,
                        );
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      sx={{
                        width: "100%",
                        fontWeight: classRequestDet.opsApprovalDate
                          ? "normal"
                          : 300,
                        color: classRequestDet.opsApprovalDate
                          ? "#3f5765"
                          : "#888",
                      }}
                    />
                  </Grid>
                  <Grid className={classes.keyData} item xs={12}>
                    <span
                      className={classes.spanTagNecessary}
                      onClick={(e) => handleOpenSearch("OpsApproval")}
                      onKeyDown={(e) => handleOpenSearch("OpsApproval")}
                    >
                      {t("OpsApprover")} {<SearchIcon />}
                    </span>
                  </Grid>
                  <Grid className={classes.valueData} item xs={8}>
                    <TextField
                      id="date"
                      name="opsName"
                      className={classes.allData}
                      value={formatOpsName(
                        classRequestDet.opsName,
                        classRequestDet.opsApproverOracleId,
                      )}
                      disabled
                      variant="outlined"
                      sx={{
                        "& .MuiInputBase-input.Mui-disabled": {
                          color: "#3f5765",
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid container rowSpacing={2}>
          <Grid item xs={12}>
            <TextField
              value={searchKeyword}
              onChange={filter}
              placeholder="Search Project"
              className="trainee-input"
              variant="outlined"
              sx={{
                border: "3px solid #3299FF",
                borderRadius: "4px",
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Paper
                  elevation={3}
                  sx={{
                    width: 350,
                    height: 500,
                    overflow: "auto",
                    border: "3px solid #3299FF",
                    borderRadius: "10px",
                    boxSizing: "border-box",
                  }}
                >
                  <List dense>
                    {projectFoundList.map((project) => {
                      const labelId = `left-${project.projectCode}`;
                      return (
                        <ListItem
                          key={project.projectCode}
                          onClick={() => handleToggle(project)}
                        >
                          <ListItemIcon>
                            <Checkbox
                              checked={checked.some(
                                (p) => p.projectCode === project.projectCode,
                              )}
                              tabIndex={-1}
                              disableRipple
                              inputProps={{ "aria-labelledby": labelId }}
                            />
                          </ListItemIcon>
                          <Tooltip
                            title={`${project.projectName} (${project.projectCode})`}
                            arrow
                          >
                            <ListItemText
                              id={labelId}
                              primary={`${project.projectName} (${project.projectCode})`}
                            />
                          </Tooltip>
                        </ListItem>
                      );
                    })}
                  </List>
                </Paper>
              </Grid>

              <Grid item>
                <Grid container direction="column" alignItems="center">
                  <Tooltip title="Move all to right" arrow>
                    <span>
                      <Button
                        sx={{ my: 1, cursor: "pointer" }}
                        variant="outlined"
                        size="small"
                        onClick={handleAllRight}
                        disabled={left.length === 0}
                      >
                        ≫
                      </Button>
                    </span>
                  </Tooltip>
                  <Tooltip title="Move selected to right" arrow>
                    <span>
                      <Button
                        sx={{ my: 1, cursor: "pointer" }}
                        variant="outlined"
                        size="small"
                        onClick={handleCheckedRight}
                        disabled={leftChecked.length === 0}
                      >
                        &gt;
                      </Button>
                    </span>
                  </Tooltip>
                  <Tooltip title="Move selected to left" arrow>
                    <span>
                      <Button
                        sx={{ my: 1, cursor: "pointer" }}
                        variant="outlined"
                        size="small"
                        onClick={handleCheckedLeft}
                        disabled={rightChecked.length === 0}
                      >
                        &lt;
                      </Button>
                    </span>
                  </Tooltip>
                  <Tooltip title="Move all to left" arrow>
                    <span>
                      <Button
                        sx={{ my: 1, cursor: "pointer" }}
                        variant="outlined"
                        size="small"
                        onClick={handleAllLeft}
                        disabled={right.length === 0}
                      >
                        ≪
                      </Button>
                    </span>
                  </Tooltip>
                </Grid>
              </Grid>

              <Grid item>
                <Paper
                  elevation={3}
                  sx={{
                    width: 350,
                    height: 500,
                    overflow: "auto",
                    border: "3px solid #3299FF",
                    borderRadius: "10px",
                    boxSizing: "border-box",
                  }}
                >
                  <List dense>
                    {selectedProject.map((project) => {
                      const labelId = `right-${project.projectCode}`;
                      return (
                        <ListItem
                          key={project.projectCode}
                          onClick={() => handleToggle(project)}
                        >
                          <ListItemIcon>
                            <Checkbox
                              checked={checked.some(
                                (p) => p.projectCode === project.projectCode,
                              )}
                              tabIndex={-1}
                              disableRipple
                              inputProps={{ "aria-labelledby": labelId }}
                            />
                          </ListItemIcon>
                          <Tooltip
                            title={`${project.projectName} (${project.projectCode})`}
                            arrow
                          >
                            <ListItemText
                              id={labelId}
                              primary={`${project.projectName} (${project.projectCode})`}
                            />
                          </Tooltip>
                        </ListItem>
                      );
                    })}
                  </List>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
      {!showProject ? (
        <Grid container className={classes.gridContainer}>
          <Grid item xs={8.5}></Grid>
          {props.type === "edit" && (
            <Grid item xs={1.5}>
              <CustomButton
                onClick={updateClassRequest}
                variant="contained"
                type="button"
              >
                {t("Update")}
              </CustomButton>
            </Grid>
          )}
          {props.type === "add" && (
            <Grid item xs={1.5}>
              <CustomButton
                variant="contained"
                disabled={disableCreate}
                onClick={createClassReq}
                type="button"
              >
                {t("Add")}
              </CustomButton>
            </Grid>
          )}
          {props.type === "edit" && (
            <Grid item xs={1.5}>
              <CustomButton
                variant="outlined"
                onClick={(e) => handleReset(classRequestDet.classRequestId)}
                type="button"
              >
                {t("Reset")}
              </CustomButton>
            </Grid>
          )}
          {props.type === "add" && (
            <Grid item xs={1.5}>
              <CustomButton
                onClick={resetHandler}
                variant="outlined"
                type="button"
              >
                {t("Reset")}
              </CustomButton>
            </Grid>
          )}
        </Grid>
      ) : (
        <Grid container sx={{ marginTop: "30px" }}>
          <Grid item xs={5.5}></Grid>
          <Grid item xs={2} sx={{ width: "100%" }}>
            <CustomButton
              variant="contained"
              onClick={showFormField}
              sx={{ width: "80px" }}
            >
              Done
            </CustomButton>
          </Grid>
          <Grid item xs={4.5}></Grid>
        </Grid>
      )}
    </>
  );
};

ClassRequestEdit.propTypes = {
  type: PropTypes.string,
  classRequestDetails: PropTypes.any,
  onClose: PropTypes.func,
  onUpdate: PropTypes.func,
};

export default ClassRequestEdit;
